// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ArticleSocial } from './ArticleSocial';
/**
 * @author Sebastian Dziechciarz <sebastian.dziechciarz@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let ArticleSocials = class ArticleSocials extends Vue {
};
__decorate([
    Prop({ type: Array, required: true })
], ArticleSocials.prototype, "enabledServices", void 0);
__decorate([
    Prop({ type: Function, required: true })
], ArticleSocials.prototype, "onClick", void 0);
ArticleSocials = __decorate([
    Component({
        name: 'ArticleSocials',
        components: { ArticleSocial },
        template: `
    <ul class="article-socials list-inline mb-0">
    <li v-for="service in enabledServices" :key="service"
        class="article-socials__item list-inline-item p-0">
      <ArticleSocial :icon="service" :title="$t('share.' + service)" @click="onClick(service)" />
    </li>
    </ul>
  `
    })
], ArticleSocials);
export { ArticleSocials };
export default ArticleSocials;
